import React, { useState } from 'react';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import Button from '@app/react-common/components/button/Button';
import { DragHandle } from '@app/react-common/components/drag-handle/DragHandle';
import { InlineSectionNameInput } from './InlineSectionNameInput';

interface DeliveryMethodSectionHeaderProps {
  sectionName: string;
  deliveryMethodCountLabel: string;
  isCollapsed: boolean;
  canCollapse: boolean;
  onToggleCollapsed: () => void;
  dragHandleProps?: DraggableProvidedDragHandleProps | null;
  onRenameSection?: (sectionName: string) => void;
  onDeleteSection?: () => void;
}

export const DeliveryMethodSectionHeader = ({
  sectionName,
  deliveryMethodCountLabel,
  isCollapsed,
  canCollapse,
  onToggleCollapsed,
  dragHandleProps,
  onRenameSection,
  onDeleteSection,
}: DeliveryMethodSectionHeaderProps) => {
  const [isRenaming, setIsRenaming] = useState(false);

  if (isRenaming && onRenameSection) {
    return (
      <div className="delivery-method-sections__header">
        <InlineSectionNameInput
          initialName={sectionName}
          onSubmitName={(renamedSectionName) => {
            onRenameSection(renamedSectionName);
            setIsRenaming(false);
          }}
          onCancel={() => setIsRenaming(false)}
        />
      </div>
    );
  }

  return (
    <div className="delivery-method-sections__header">
      {dragHandleProps && <DragHandle dragHandleProps={dragHandleProps} accessibleLabel={`Reorder ${sectionName}`} />}
      {onRenameSection ? (
        <button
          type="button"
          className="delivery-method-sections__header__rename-button"
          aria-label={`Rename section ${sectionName}`}
          onClick={() => setIsRenaming(true)}>
          <span className="delivery-method-sections__header__name">{sectionName}</span>
        </button>
      ) : (
        <span className="delivery-method-sections__header__name">{sectionName}</span>
      )}
      <span className="delivery-method-sections__header__count">{deliveryMethodCountLabel}</span>
      <div className="delivery-method-sections__header__actions">
        {onDeleteSection && (
          <Button
            variant="ghost"
            size="small"
            className="delivery-method-sections__icon-button"
            icon="trash"
            ariaLabel={`Delete section ${sectionName}`}
            onClick={onDeleteSection}
          />
        )}
        {canCollapse && (
          <Button
            variant="ghost"
            size="small"
            className={`delivery-method-sections__icon-button delivery-method-sections__chevron ${
              isCollapsed ? 'delivery-method-sections__chevron--collapsed' : ''
            }`}
            icon="arrow_down"
            ariaLabel={isCollapsed ? `Expand ${sectionName}` : `Collapse ${sectionName}`}
            onClick={onToggleCollapsed}
          />
        )}
      </div>
    </div>
  );
};
